import { render, staticRenderFns } from "./VatInfoStep.vue?vue&type=template&id=2db5db38"
import script from "./VatInfoStep.vue?vue&type=script&lang=ts"
export * from "./VatInfoStep.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports